import { AdvancedHostingActionTypes } from './advancedHosting.types';

const requestListServers = payload => ({
  type: AdvancedHostingActionTypes.ADVANCED_HOSTING_LIST_REQUEST,
  payload,
});
const successListServers = payload => ({
  type: AdvancedHostingActionTypes.ADVANCED_HOSTING_LIST_SUCCESS,
  payload,
});
const failureListServers = payload => ({
  type: AdvancedHostingActionTypes.ADVANCED_HOSTING_LIST_FAILURE,
  payload,
});
const loadingListServers = payload => ({
  type: AdvancedHostingActionTypes.ADVANCED_HOSTING_LIST_LOADING,
  payload,
});

const requestUpdateServer = payload => ({
  type: AdvancedHostingActionTypes.ADVANCED_HOSTING_UPDATE_SERVER_REQUEST,
  payload,
});
const successUpdateServer = payload => ({
  type: AdvancedHostingActionTypes.ADVANCED_HOSTING_UPDATE_SERVER_SUCCESS,
  payload,
});
const failureUpdateServer = payload => ({
  type: AdvancedHostingActionTypes.ADVANCED_HOSTING_UPDATE_SERVER_FAILURE,
  payload,
});
const loadingUpdateServer = payload => ({
  type: AdvancedHostingActionTypes.ADVANCED_HOSTING_UPDATE_SERVER_LOADING,
  payload,
});

const setLastListParamsServers = payload => ({
  type: AdvancedHostingActionTypes.ADVANCED_HOSTING_SET_LAST_LIST_PARAMS,
  payload,
});

const requestServerStatus = payload => ({
  type: AdvancedHostingActionTypes.ADVANCED_HOSTING_SERVER_STATUS_REQUEST,
  payload,
});
const successServerStatus = payload => ({
  type: AdvancedHostingActionTypes.ADVANCED_HOSTING_SERVER_STATUS_SUCCESS,
  payload,
});
const failureServerStatus = payload => ({
  type: AdvancedHostingActionTypes.ADVANCED_HOSTING_SERVER_STATUS_FAILURE,
  payload,
});
const loadingServerStatus = payload => ({
  type: AdvancedHostingActionTypes.ADVANCED_HOSTING_SERVER_STATUS_LOADING,
  payload,
});

const actions = {
  list: {
    request: requestListServers,
    success: successListServers,
    failure: failureListServers,
    loading: loadingListServers,
    setLastListParams: setLastListParamsServers,
  },
  updateServer: {
    request: requestUpdateServer,
    success: successUpdateServer,
    failure: failureUpdateServer,
    loading: loadingUpdateServer,
  },
  serverStatus: {
    request: requestServerStatus,
    success: successServerStatus,
    failure: failureServerStatus,
    loading: loadingServerStatus,
  },
};

export default actions;
